import type { TOC } from '@ember/component/template-only';
import { PrismLoadingBar } from '@mylighthouse/prism-ember';
import SettingsRecommendationsPriceRange from 'lumen/components/settings/recommendations/price-range';
import type HotelSettingsRecommendationsPriceRangeRoute from 'lumen/routes/hotel/settings/recommendations/price-range';
import type { ModelFrom } from 'lumen/utils/routes';

interface HotelSettingsRecommendationsPriceRangeSignature {
  Args: {
    controller: unknown;
    model: ModelFrom<HotelSettingsRecommendationsPriceRangeRoute>;
  };
}

<template>
  {{! Gates on the request, not on the value: a hotel with no saved preference still renders }}
  {{#if @model.ratePreferenceTaskResult.isRunning}}
    <PrismLoadingBar />
  {{else}}
    <SettingsRecommendationsPriceRange @model={{@model}} />
  {{/if}}
</template> satisfies TOC<HotelSettingsRecommendationsPriceRangeSignature>;
